import React from "react";
import { TouchableOpacity as NativeButton, } from "react-native";
import { Text } from "../Text/Text";
import { styles, outlineStyles, sizeStyles, sizeTextStyles, } from "./Button.styles";
export const Button = ({ color = "brand", variant = "fill", children, styles: userStyles, size = "large", disabled, ...rest }) => {
    return (React.createElement(NativeButton, { style: [
            styles.defaultStyle,
            disabled && styles.disabled,
            variant === "fill" && styles[color],
            variant === "outline" && outlineStyles[color],
            sizeStyles[size],
            userStyles,
        ], disabled: disabled, ...rest, accessibilityRole: "button" }, typeof children === "string" ? (React.createElement(Text, { style: [
            styles.buttonText,
            variant === "fill" && styles[color],
            variant === "outline" && outlineStyles[color],
            sizeTextStyles[size],
            { backgroundColor: "transparent" },
        ] }, children)) : (children)));
};
//# sourceMappingURL=Button.js.map